import React from 'react';

import { Slide } from '@core/transitions/Slide';
import type { SlideProps } from '@core/transitions/Slide';

type SlideUpProps = Omit<SlideProps, 'direction'>;

const SlideUp = (
  props: SlideUpProps,
  ref: React.Ref<HTMLElement>
): React.ReactElement | null => {
  return <Slide ref={ref} direction="up" {...props} />;
};

export default React.forwardRef<HTMLElement, SlideUpProps>(SlideUp);
